import React from 'react';
import InputBase from '@material-ui/core/InputBase';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
var useStyles = makeStyles(function (theme) { return ({
    root: function (props) {
        var border = '0x none transparent';
        if (!props.isErrorField) {
            border = props.bordered ? "1px solid ".concat(theme.commonSettings.borderColor) : '1px dotted transparent';
        }
        return {
            height: theme.commonSettings.inputHeight || '14px',
            boxSizing: 'border-box',
            overflow: 'hidden',
            maxWidth: props.width || 'inherit',
            border: border,
            borderRadius: theme.shape.borderRadius,
        };
    },
    error: function (props) { return ({
        border: '1px solid red',
        maxWidth: props.width || 'inherit',
        borderRadius: theme.shape.borderRadius,
    }); },
    input: function (props) { return ({
        color: props.disabled ? theme.commonSettings.disabledColor : '',
        padding: '0 4px',
        height: theme.commonSettings.inputHeight || '14px',
        fontSize: theme.typography.fontSize || '12px',
        width: '100%',
        backgroundColor: 'rgba(0,0,0,0)',
        '&:disabled': {
            backgroundColor: 'rgba(0,0,0,0)',
            fontStyle: 'italic',
        },
    }); },
}); });
/**
 * @deprecated
 * Use `TextInput` to render a text input inside your project
 */
var TextInput = React.forwardRef(function (props, ref) {
    var className = props.className, onChange = props.onChange, onBlur = props.onBlur, onFocus = props.onFocus, onKeyDown = props.onKeyDown, value = props.value, name = props.name, placeholder = props.placeholder, disabled = props.disabled, isErrorField = props.isErrorField, defaultValue = props.defaultValue, fullWidth = props.fullWidth, autoFocus = props.autoFocus, required = props.required, endAdornment = props.endAdornment, startAdornment = props.startAdornment, autoComplete = props.autoComplete, readOnly = props.readOnly, onSelect = props.onSelect;
    var classes = useStyles(props);
    return (React.createElement(InputBase, { onChange: onChange, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, value: value, name: name, placeholder: placeholder, disabled: disabled, error: isErrorField, fullWidth: fullWidth, classes: {
            root: classNames(classes.root, className),
            error: classes.error,
            input: classes.input,
        }, defaultValue: defaultValue, autoFocus: autoFocus, required: required, endAdornment: endAdornment, startAdornment: startAdornment, autoComplete: autoComplete, inputRef: ref, readOnly: readOnly, onSelect: onSelect }));
});
TextInput.defaultProps = {
    autoFocus: false,
    fullWidth: false,
    required: false,
    disabled: false,
    isErrorField: false,
    autoComplete: 'off',
    name: '',
};
export default TextInput;
//# sourceMappingURL=TextInput.js.map